import React from 'react';
import { FaShieldAlt } from 'react-icons/fa';
import { FiRadio, FiCheck, FiAlertTriangle, FiWifiOff, FiThermometer } from 'react-icons/fi';

const SystemMetricsBar = () => {
  return (
    <div className="w-full bg-[#FAFDFB] border border-[#008A43] rounded-xl px-5 py-10 font-sans flex flex-col lg:flex-row items-center justify-between gap-6 shadow-[0_2px_12px_rgba(0,0,0,0.01)] select-none my-10">
      
      {/* Left Box: System Overall Shield Alert Status Banner */}
      <div className="flex items-center gap-4 border-b lg:border-b-0 lg:border-r border-gray-100 pb-4 lg:pb-0 lg:pr-8 w-full lg:w-auto shrink-0">
        {/* Large Green Check Shield */}
        <div className="relative text-[#008A43] shrink-0">
          <FaShieldAlt className="w-14 h-14 fill-current" />
          <div className="absolute inset-0 flex items-center justify-center text-white pb-0.5">
            <FiCheck className="w-5 h-5 stroke-[3.5]" />
          </div>
        </div>
        {/* Banner Text description layout lines */}
        <div className="space-y-0.5">
          <h2 className="text-[17px] font-bold text-[#008A43] tracking-tight">
            All Systems Normal
          </h2>
          <p className="text-[12px] font-semibold text-gray-500 max-w-[210px] leading-snug">
            All monitored equipment is operating within safe temperature ranges.
          </p>
        </div>
      </div>

      {/* Right Grid: Individual Metric Data Blocks */}
      <div className="grid grid-cols-2 sm:grid-cols-5 items-center justify-between w-full divide-x-0 sm:divide-x divide-gray-100 gap-y-6 sm:gap-y-0">
        
        {/* Metric Item 1: Total Sensors */}
        <div className="flex items-center gap-3 pl-0 sm:pl-4">
          <div className="w-10 h-10 bg-[#E8F8EE] text-[#008A43] rounded-full flex items-center justify-center shrink-0">
            <FiRadio className="w-5 h-5 stroke-[2]" />
          </div>
          <div className="space-y-0.5">
            <span className="text-[11px] font-bold text-gray-400 block tracking-tight">Total Sensors</span>
            <p className="text-[20px] font-extrabold text-gray-900 leading-none">16</p>
            <span className="text-[11px] font-bold text-gray-400 block">Online 15 (94%)</span>
          </div>
        </div>

        {/* Metric Item 2: In Range */}
        <div className="flex items-center gap-3 pl-0 sm:pl-6">
          <div className="w-10 h-10 bg-[#E8F8EE] text-[#008A43] rounded-full flex items-center justify-center shrink-0">
            <FiCheck className="w-5 h-5 stroke-[2.5]" />
          </div>
          <div className="space-y-0.5">
            <span className="text-[11px] font-bold text-gray-400 block tracking-tight">In Range</span>
            <p className="text-[20px] font-extrabold text-gray-900 leading-none">14</p>
            <span className="text-[11px] font-bold text-gray-400 block">88%</span>
          </div>
        </div>

        {/* Metric Item 3: Alerts */}
        <div className="flex items-center gap-3 pl-0 sm:pl-6">
          <div className="w-10 h-10 bg-[#FFF3E0] text-[#FF9800] rounded-full flex items-center justify-center shrink-0">
            <FiAlertTriangle className="w-5 h-5 stroke-[2.2]" />
          </div>
          <div className="space-y-0.5">
            <span className="text-[11px] font-bold text-gray-400 block tracking-tight">Alerts</span>
            <p className="text-[20px] font-extrabold text-gray-900 leading-none">1</p>
            <span className="text-[11px] font-bold text-gray-400 block">6%</span>
          </div>
        </div>

        {/* Metric Item 4: Offline */}
        <div className="flex items-center gap-3 pl-0 sm:pl-6">
          <div className="w-10 h-10 bg-[#F3F4F6] text-gray-600 rounded-full flex items-center justify-center shrink-0">
            <FiWifiOff className="w-5 h-5 stroke-[2]" />
          </div>
          <div className="space-y-0.5">
            <span className="text-[11px] font-bold text-gray-400 block tracking-tight">Offline</span>
            <p className="text-[20px] font-extrabold text-gray-900 leading-none">0</p>
            <span className="text-[11px] font-bold text-gray-400 block">0%</span>
          </div>
        </div>

        {/* Metric Item 5: Avg. Temperature */}
        <div className="flex items-center gap-3 pl-0 sm:pl-6">
          <div className="w-10 h-10 bg-[#F3E8FF] text-[#7C3AED] rounded-full flex items-center justify-center shrink-0">
            <FiThermometer className="w-5 h-5 stroke-[2]" />
          </div>
          <div className="space-y-0.5">
            <span className="text-[11px] font-bold text-gray-400 block tracking-tight">Avg. Temperature</span>
            <p className="text-[20px] font-extrabold text-gray-900 leading-none tracking-tight">2.6°C</p>
            <span className="text-[11px] font-bold text-gray-400 block">All sensors</span>
          </div>
        </div>

      </div>

    </div>
  );
};

export default SystemMetricsBar;
